module.exports = __webpack_public_path__ + "static/media/responsive.3dd36303.png";